import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { calculateTotalRow, checkForTotalColumn, tableColumns } from "./data";
import { datatypes, deleteTableColumn } from "data/globalData";
import { useEffect, useState } from "react";
import { GlobalState } from "context/GlobalContext";
import { Button, Typography } from "@mui/material";
import { AddRounded, EditRounded } from "@mui/icons-material";
import { getColDefaultValue } from "components/PimDashboard/data";
import { DisabledBox, TotalBox, WhiteBgBox } from "../data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";
import { AuthState } from "context/AuthContext";
const colStyle = {
	headerAlign: "center",
	align: "center",
	minWidth: 133,
};

const DynamicTrimConsumption = ({
	rows,
	setRows,
	totalRow,
	setTotalRow,
	mode = "" || "create" || "edit",
	editMode = false,
	setEditMode = () => {},
	handleSave = () => [],
}) => {
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();

	const defTableColumns = [
		{
			...tableColumns.trims_id,
			...colStyle,
			minWidth: 0,
			editable: true,
			flex: 1,
			headerName: tableColumns.trims_id.name,
			field: tableColumns.trims_id.key,
			colSpan: (value, row) => {
				if (checkForTotalColumn(row)) {
					return 6;
				}
				return undefined;
			},
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.category,
			editable: true,
			flex: 1,
			valueOptions: [],
			...colStyle,
			headerName: tableColumns.category.name,
			field: tableColumns.category.key,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.description,
			editable: true,
			flex: 1,
			valueOptions: [],
			...colStyle,
			headerName: tableColumns.description.name,
			field: tableColumns.description.key,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.supplier,
			field: tableColumns.supplier.key,
			headerName: tableColumns.supplier.name,
			flex: 1,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.trim_cost,
			field: tableColumns.trim_cost.key,
			headerName: tableColumns.trim_cost.name,
			flex: 1,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.no_of_pcs_per_carton,
			field: tableColumns.no_of_pcs_per_carton.key,
			headerName: tableColumns.no_of_pcs_per_carton.name,
			flex: 1,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.value,
			field: tableColumns.value.key,
			headerName: tableColumns.value.name,
			flex: 1,
			// editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <DisabledBox field={field} row={row} />;
			},
		},
	];

	const [packingTrimsColumns, setPackingTrimsColumns] = useState([]);
	const [rowsCopy, setRowsCopy] = useState(rows ? [...rows] : []);
	const [deletedRowIds, setDeletedRowIds] = useState([]);

	const defaultRow = packingTrimsColumns?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	useEffect(() => {
		setPackingTrimsColumns([...defTableColumns]);
		setTotalRow(calculateTotalRow(rows));
	}, []);

	const handleAddRowClick = () => {
		let newRow = { ...defaultRow };
		newRow["id"] = new Date().valueOf();
		newRow["is_new"] = true;
		newRow["created_by"] = user.email;

		setRows((prev) => [...prev, newRow]);
	};
	const handleDeleteRowClick = (rowToDelete) => {
		setRows((prev) => {
			const newRows = prev.filter((row) => row.id !== rowToDelete.id);
			setDeletedRowIds((prev) => [...prev, rowToDelete.id]);
			setTotalRow(calculateTotalRow(newRows));
			return newRows;
		});
	};
	const processRowUpdate = (New, OldRow) => {
		let newRow = { ...New };
		let correct = true;

		packingTrimsColumns?.forEach((col) => {
			if (col.data_type === datatypes.NUMBER.key || col.data_type === datatypes.DECIMAL.key) {
				if (isNaN(parseFloat(newRow[col.key])) && newRow[col.key] !== "") correct = false;
			}
		});

		if (correct) {
			let noOfPcs = parseFloat(newRow?.[tableColumns.no_of_pcs_per_carton.key]) || 0;
			let trimPrice = parseFloat(newRow?.[tableColumns.trim_cost.key]) || 0;

			const value = noOfPcs > 0 ? trimPrice / noOfPcs : 0;

			newRow = {
				...newRow,
				[tableColumns.value.key]: value,
				is_updated: true,
				last_updated_by: user.email,
			};

			setRows((prev) => {
				const newRows = prev.map((row) => (row.id === newRow.id ? newRow : row));
				setTotalRow(calculateTotalRow(newRows));
				return newRows;
			});

			return newRow;
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please Enter Proper Numeric Values",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const handleCancelEditClick = () => {
		setRows(rowsCopy);
		setDeletedRowIds([]);
		setEditMode(false);
	};
	const handleEditClick = () => {
		setEditMode(true);
	};
	const handleSaveClick = async () => {
		try {
			setLoadingOpen(true);
			const result = await handleSave(rows, deletedRowIds);
			if (result) {
				setRows(result);
				setRowsCopy(result);
				setDeletedRowIds([]);
				setEditMode(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data Saved Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	return (
		<Box width="100%">
			<Box display="flex" justifyContent="space-between" pt={1} pb={1}>
				<Typography variant="h6">Carton & Tape (Dynamic Consumption)</Typography>
				<Box display="flex" columnGap="5px">
					{mode === "create" ? (
						<Button variant="contained" size="small" onClick={handleAddRowClick} startIcon={<AddRounded />}>
							Add Row
						</Button>
					) : mode === "edit" ? (
						<>
							{editMode ? (
								<>
									<Button variant="contained" size="small" onClick={handleAddRowClick} startIcon={<AddRounded />}>
										Add Row
									</Button>
									<Button variant="outlined" size="small" onClick={handleCancelEditClick}>
										Cancel Edit
									</Button>
									<Button variant="contained" size="small" onClick={handleSaveClick}>
										Save
									</Button>
								</>
							) : (
								<Button variant="contained" size="small" onClick={handleEditClick} startIcon={<EditRounded />}>
									Edit
								</Button>
							)}
						</>
					) : (
						<></>
					)}
				</Box>
			</Box>
			<Box width="100%">
				<DataGrid
					rows={rows ? [...rows, totalRow] : []}
					getRowId={(row) => row.id}
					columns={[
						...packingTrimsColumns,
						deleteTableColumn(handleDeleteRowClick, (row) => (mode !== "create" && !editMode) || checkForTotalColumn(row)),
					]}
					sx={{
						width: "100%",
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-row:hover": {
							backgroundColor: "transparent",
						},

						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[400],
							textTransform: "uppercase",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					}}
					disableRowSelectionOnClick
					pagination={false} // Remove footer
					hideFooter={true}
					disableAutosize
					showCellVerticalBorder
					showColumnVerticalBorder
					density="compact"
					isCellEditable={({ row }) => (mode === "create" || editMode) && !checkForTotalColumn(row)}
					processRowUpdate={processRowUpdate}
					autoHeight
				/>
			</Box>
		</Box>
	);
};

export default DynamicTrimConsumption;
